export default {
  ORDER_NUMBER: {
    label: 'Pedido',
    placeholder: 'Informe um ou mais pedidos',
  },
  INVOICE_NUMBER: {
    label: 'Nota Fiscal',
    placeholder: 'Informe uma ou mais NFs',
  },
  INVOICE_KEY: {
    label: 'Chave de acesso da NF',
    placeholder: 'Informe uma ou mais chaves de acesso da NF',
  },
  CTE_NUMBER: {
    label: 'CTe',
    placeholder: 'Informe um ou mais CTes',
  },
  CTE_KEY: {
    label: 'Chave de acesso do CTe',
    placeholder: 'Informe um ou mais chaves de acesso do CTe',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice/enum/seach-value-fields.enum.js